import { api } from '@cwd/lib/main';

export interface Category {
    CategoryId: string;
    Name: string;
    Description: string;
    IsPublic: boolean;
    IgnoreUnsubscribe: boolean;
    AllowedDays: number | null;
    AllowedFromTime: string | null;
    AllowedToTime: string | null;
    AllowedTimezone: string | null;
}

export async function getCategories(): Promise<Category[]> {
    return api.get('/Categories');
}

export async function saveCategory(category: Partial<Category>): Promise<Category> {
    return api.post('/Categories', category);
}
